import React from 'react';

function BlogNewsletter() {
  return (
	  <div className="widget sidebar-newsletter">
                  <div className="sn-icon">
                    <img src="img/icon/sn_icon.png" alt="" />
                  </div>
                  <div className="sn-title">
                    <h4 className="title"> Newsletter</h4>
                    <p>Inscrivez-vous pour les dernières nouvelles

</p>
                  </div>
                  <form className="sn-form">
                    <input type="text" placeholder="Enter Your Email" />
                    <button className="btn">Abonnez-vous</button>
                  </form>
                </div>
  )
}

export default BlogNewsletter;
